import React from 'react'
import styles from './PaymentSuccess.scss'
import { CTA } from 'common/styleguide/CTA'
import { commonCTAs, Msg } from 'lib/localization'
import { FormattedMessage as T } from 'react-intl'

export const PaymentSuccess = ({ onRequestClose }) => <div className={styles.PaymentSuccess}>
  <div className={styles.withPadding}>
    <h2><T id='PaymentSuccess.thanks' defaultMessage='Thank You!' /></h2>
  </div>
  <div className={styles.line} />
  <div className={styles.next}>
    <T id='PaymentSuccess.appreciation' defaultMessage='Thank you! We appreciate your support and can’t wait to see where you are riding!' />
  </div>
  <div className={styles.toProfile}>
    {onRequestClose && <CTA onClick={onRequestClose}>
      <Msg m={commonCTAs.close} />
    </CTA>}
    {!onRequestClose && <CTA href='/'>
      <T id='PaymentSuccess.goToProfile' defaultMessage='Go to Profile' />
    </CTA>}
  </div>
</div>
